import { useMutation } from '@tanstack/react-query';
import { useUploadRepository } from '~/adapters/services/upload/rest';

export const usePresignedUrl = () => {
    const uploadRepository = useUploadRepository();

    return useMutation({
        mutationKey: ['presigned-url'],
        mutationFn: uploadRepository.getPresignedUrl,
    });
};

export const useAnalyzeFiles = () => {
    const uploadRepository = useUploadRepository();

    return useMutation({
        mutationKey: ['analyze-file'],
        mutationFn: uploadRepository.analyzeFiles,
    });
};

export const useUploadFilesToS3WithPresignedUrl = () => {
    const uploadRepository = useUploadRepository();

    return useMutation({
        mutationKey: ['upload-files-to-s3-with-presigned-url'],
        mutationFn: uploadRepository.uploadFilesToS3WithPresignedUrl,
    });
};
